import React from "react"

import Layout from "../components/layout"
import Link from "../components/Link"
import Seo from "../components/seo"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"

const TrustPage = props => {
  const {
    breadcrumb: { crumbs },
  } = props.pageContext
  const customCrumbLabel = props.location.pathname
    .replace("-", " ")
    .replace(/\//g, "")

  return (
    <Layout location={props.location}>
      <Seo
        title="Trust"
        lang="da-DK"
        description="Tillid er en vigtig del af vores DNA"
        pathname="trust"
      />
      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner">
            <Breadcrumb
              crumbs={crumbs}
              crumbSeparator=" / "
              crumbLabel={customCrumbLabel}
            />
          </div>
        </div>
      </div>

      <div className="content-wide">
        <div className="wide-container">
          <div className="wide-inner trust grid gap">
            <div className="g-2col">
              <h1>Trust</h1>
              <h2 className="subHeader">
                Tillid er en integreret del af vores DNA
              </h2>
              <p>
                Hos Emento arbejder vi på at skabe fundamentet for god
                kommunikation mellem borgeren og den offentlige sektor. En af
                forudsætningerne for vores forretning, er en tillid til, at den
                digitale kommunikation af persondata bliver håndteret korrekt.
                Det betyder, at vi skal have styr på både datasikkerhed,
                databeskyttelse og dataetik.
              </p>
              <p>
                Vi har derfor i Emento konstant fokus på at sikre, at vores
                services lever op til de vedtagne standarder for god IT-skik,
                herunder fx GDPR.
                <br />
                Hvis der ikke er tillid til vores håndtering af følsomme
                personoplysninger, så vil Emento miste det vi betragter som
                vores 'License to Operate'.
                <br />
                Tillid er derfor en afgørende del af DNA'et i vores services og
                i vores forretningsmodel.
              </p>
              <p>
                <b>
                  Fordi vi arbejder med patientdata sætter vi høje krav til os
                  selv
                </b>
                , men vi vurderer at alle virksomheder kommer til at tage
                stilling til nogle af de samme etiske spørgsmål efterhånden som
                verden bliver mere og mere digital.
              </p>
              <p>
                <b>Vi har et Mantra</b> - Vi behandler dine data på samme måde
                som vi ønsker vores egne data skal behandles.
              </p>
              <p>
                Som patient og borger har man særligt ofte brug for vores
                løsning i situationer, hvor man for det første er ekstra sårbar
                og hvor der er behov for at dele sensitive data.
              </p>
              <h2 className="subHeader">
                Emento ser først og fremmest IT-sikkerhed og dataetik, som en
                'hygiejnefaktor'. Der skal ganske enkelt være orden i sagerne.
              </h2>
              <p>
                IT-sikkerhed, databeskyttelse og informationssikkerhed er det vi
                må, dataetik er det vi vil - et valg. Begge dele er en
                forudsætning, når man vil levere en service til sundhedsvæsenet.
              </p>
              <h2 className="subHeader">
                I Emento er dataetik en del af det arbejde vi kalder TRUST
              </h2>
              <p>
                TRUST betyder ikke noget mere avanceret end 'tillid', men det er
                til gengæld altafgørende og omfatter dataetik, databeskyttelse,
                GDPR, informationssikkerhed, cybersikkerhed, compliance og andre
                aspekter der måtte have indflydelse på tilliden mellem os og
                vores interessenter.
              </p>
              <p>
                <b>
                  Det kræver af os, at vi konstant ligger på et højt niveau af
                  ansvarlighed, sikkerhed
                </b>{" "}
                - og at vores kunder har fuld tillid til vores løsning. Derfor
                har vi siden 2017 arbejdet målrettet med dataetik i alle
                aspekter af vores egen virksomhed.
              </p>
              <p>
                Det betyder, at vi tager hånd om hvad der foregår i
                værdikæderne, beskytter både dem der bruger vores data - og dem
                der leverer data til os.
              </p>
              <p>
                Vi tager kort sagt ansvar for andre menneskers rettigheder, når
                det kommer til data.
              </p>
              <p>
                <b>Afgrænsning er helt klart den største udfordring</b> - det
                vil sige identifikation og håndtering af de dataetiske
                dilemmaer. Det kræver, at vi tør sige ja og nej.
              </p>
              <p>
                Med kunstig intelligens, som vi har ind over os nu - og voksende
                datasæt, så har vi brug for både mod og indsigt, så vi kan
                identificere og anvende data på mange forskellige - og mange
                helt nye måder, som hver især kræver en særskilt
                beslutningsproces.
              </p>
            </div>
            <div className="g-2col">
              <img
                src="https://images.ctfassets.net/8eaotls8wqkz/4w8U2xFVamnovMkx9JinYK/2d8eb540dd9b6e71bf0d1c91ea67c13a/IMG_7320.jpg?w=960&h=539&q=50&fm=webp"
                alt="Digitaliseringsminister Marie Bjerre, DI:Digital og Finansforbundet overrækker Dataetik Prisen 2023 til Co-founder Mikkel Bech og DPO Lyng Salling fra Emento"
              />
              <div className="blogpost-image-description">
                Digitaliseringsminister Marie Bjerre, DI:Digital og
                Finansforbundet overrækker Dataetik Prisen 2023 til Co-founder
                Mikkel Bech og DPO Lyng Salling fra Emento
              </div>
              <p>Læs mere her:</p>
              <Link
                className="blogpost-link"
                to="/blog/emento-vinder-dataetikprisen-2023/"
              >
                <div className="blogpost-link-image">
                  <img
                    src="https://images.ctfassets.net/8eaotls8wqkz/5fMo7NNcZiVqBqU9IQkfHD/f2a26f3d8d3c17954eec0d6ae93fa10d/dataetikprisen_2023.jpg?w=600&h=600&q=50&fm=webp"
                    alt="Emento vinder den nystiftede Dataetikpris for ekstraordinær indsats på det dataetiske område"
                  />
                </div>
                <div>
                  <div className="blogpost-link-title">
                    Emento vinder den nystiftede Dataetikpris for ekstraordinær
                    indsats på det dataetiske område
                  </div>
                </div>
              </Link>
            </div>
            <div className="space-8" />
            <div className="space-8" />
            <div className="two-col white">
              <div className="audit-description box">
                <h4>ISAE 3000 - GDPR</h4>
                En gang om året får vi udarbejdet en international anerkendt
                revisiorerklæring. For at få erklæringen, gennemgår en gruppe
                eksterne auditører alle vores processer og kontroller, som er
                relateret til GDPR. ISAE 3000-erklæringen er vores dokumentation
                - og din sikkerhed - for at vi overholde al gældende lovgivning
                på databeskyttelsesområdet. Vi stræber efter at gøre den nyeste
                erklæring tilgængelig her på siden i maj.
                <p>
                  <Link to="/pdf/Emento_AS_ISAE_3000_GDPR_FSR__Type_2.pdf">
                    Læs erklæringen her
                  </Link>
                </p>
              </div>
              <div className="audit-photo box right">
                <img
                  src="/images/trust/emento_BDO_3000.jpg"
                  alt="Emento BDO 3000 erklæring"
                />
              </div>
            </div>
            <div className="space-8" />
            <div className="space-8" />
            <div className="two-col white">
              <div className="audit-photo box">
                <img
                  src="/images/trust/emento_BDO_3402.jpg"
                  alt="Emento BDO 3402 erklæring"
                />
              </div>
              <div className="audit-description box">
                <h4>ISAE 3402 II</h4>
                Informationssikkerhed og i særdeleshed IT-sikkerhed spiller også
                en central rolle i vores arbejde med at sikre tilgængelig,
                fortrolighed og integritet i vores service. Derfor får vi - i
                tillæg til ISAE 3000-erklæringen - udarbejdet en ISAE
                3402-erklæring. Denne erklæring har fokus på vores
                risikobaserede tilgang til styring af informationssikkerheden.
                Her tager auditørerne udgangspunkt i de IT-kontroller som er
                beskrevet i ISO27001-standarden. For denne erklæring tilstræber
                vi også, at gøre den nyeste version tilgængelig her på siden i
                maj.
                <p>
                  <Link to="/pdf/Emento_AS__ISAE_3402_Type_2.pdf">
                    Læs erklæringen her
                  </Link>
                </p>
              </div>
            </div>
            <div className="space-8" />
            <div className="space-8" />
            <div className="two-col white">
              <div className="audit-description box">
                <h4>C5 Assurance Report</h4>
                C5 (Cloud Computing Compliance Criteria Catalogue) er en kritisk
                og obligatorisk sikkerhedsstandard, især for cloud-leverandører,
                der opererer i den tyske sundhedssektor. Her kræves en Type
                2-certificering for at sikre et højt beskyttelsesniveau for
                følsomme patientdata. Standarden definerer over 120 kriterier,
                herunder fysisk sikkerhed og dataintegritet.
                <p>
                  <Link to="/pdf/C5_assurance_report_Emento.pdf">
                    Læs erklæringen her
                  </Link>
                </p>
              </div>
              <div className="audit-photo box right">
                <img
                  src="/images/trust/emento_BDO_3000.jpg"
                  alt="Emento BDO C5 erklæring"
                />
              </div>
            </div>
          </div>
          <div className="space-8" />
          <div className="space-8" />
        </div>
        <div className="content-full pink">
          <div className="wide-container">
            <div className="content dpo">
              <div className="boardmember">
                <div className="boardmember-photo">
                  <img
                    src="/images/portraits/tilde.jpg"
                    alt="Tilde Holst Aaen"
                  />
                </div>
                <div className="boardmember-description">
                  <div className="boardmember-name">Tilde Holst Aaen</div>
                  <div className="boardmember-title">
                    DPO & Compliance Officer
                  </div>
                  <div className="boardmember-other">
                    <b>Om DPO-rollen:</b>
                    <p>
                      DPO (Data Protection Officer) betyder
                      Databeskyttelsesrådgiver, og Tilde er den i Emento, som
                      sparrer med ledelse og medarbejdere om alt indenfor GDPR
                      (Persondataforordningen i EU). Tilde er også den som
                      internt overvåger, at alle regler overholdes samt at
                      informations- og IT-sikkerheden er i fokus.
                    </p>
                    <p>
                      Mød Tilde på{" "}
                      <b>
                        <Link
                          to="https://www.linkedin.com/in/tildeholstaaen/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          LinkedIn
                        </Link>
                      </b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="space-8" />
    </Layout>
  )
}

export default TrustPage
